module.exports = __webpack_public_path__ + "web/img/tpsn_status_30.f5fff9cb.png";